import { BriqAgentIntegrationConfiguration } from './briqAgentTypes'
import { currentScriptSrc } from './currentScriptSrc'

export const buildAgentUrl = (
  cfg: BriqAgentIntegrationConfiguration,
  baseUrl: string = 'briq-ai-agent-override.html'
): string => {
  const url = new URL(baseUrl, currentScriptSrc())
  url.searchParams.set('configuration', JSON.stringify(cfg))
  return url.toString()
}
